import React, { useState } from "react";
import classes from "./PreviewModal.module.css";

export default function PreviewModal({
  headers = [],
  rows = [],
  total = 0,
  onClose,
  onStart,
  loadingStart,
}) {
  const [rowIndex, setRowIndex] = useState(0);
  const current = rows[rowIndex] || {};

  const next = () => setRowIndex((p) => Math.min(p + 1, rows.length - 1));
  const prev = () => setRowIndex((p) => Math.max(p - 1, 0));

  return (
    <div className={classes.overlay}>
      <div className={classes.modal}>
        <header className={classes.header}>
          Preview CSV — Row {rowIndex + 1} of {rows.length}
        </header>

        <div className={classes.body}>
          <div className={classes.rowView}>
            {headers.map((h) => {
              const value = current[h] || current[h.toLowerCase()] || "";

              // Show images if field is product_image or product_gallery
              if (["product_image", "image"].includes(h.toLowerCase())) {
                return (
                  <div key={h} className={classes.rowItem}>
                    <div className={classes.key}>{h}</div>
                    <div className={classes.value}>
                      {value ? (
                        <img
                          src={value}
                          alt={h}
                          className={classes.imageThumb}
                        />
                      ) : (
                        "No Image"
                      )}
                    </div>
                  </div>
                );
              } else if (
                ["product_gallery", "image_gallery"].includes(h.toLowerCase())
              ) {
                const urls = value
                  ? value
                      .toString()
                      .split(",")
                      .map((u) => u.trim())
                  : [];
                return (
                  <div key={h} className={classes.rowItem}>
                    <div className={classes.key}>{h}</div>
                    <div className={classes.value}>
                      {urls.length ? (
                        <div className={classes.galleryContainer}>
                          {urls.map((url, idx) => (
                            <img
                              key={idx}
                              src={url}
                              alt={`Gallery ${idx}`}
                              className={classes.imageThumb}
                            />
                          ))}
                        </div>
                      ) : (
                        "No Gallery"
                      )}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div key={h} className={classes.rowItem}>
                    <div className={classes.key}>{h}</div>
                    <div className={classes.value}>{value}</div>
                  </div>
                );
              }
            })}
          </div>
        </div>

        <footer className={classes.footer}>
          <div className={classes.controls}>
            <button
              className={classes.navBtn}
              onClick={prev}
              disabled={rowIndex === 0}
            >
              Prev
            </button>
            <button
              className={classes.navBtn}
              onClick={next}
              disabled={rowIndex >= rows.length - 1}
            >
              Next
            </button>
          </div>

          <div className={classes.actions}>
            <button
              className={classes.startBtn}
              onClick={onStart}
              disabled={loadingStart}
            >
              {loadingStart ? "Importing..." : "Upload File (Start Import)"}
            </button>
            <button className={classes.closeBtn} onClick={onClose}>
              Close
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
}
